<script setup>
import { computed } from 'vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  items: { type: Array, required: true },
  selectAllLabel: { type: String, required: true },
  unselectAllLabel: { type: String, required: true },
  selectedLabel: { type: String, required: true },
  deleteLabel: { type: String, required: true },
});

const emit = defineEmits(['bulkDelete']);
const selectedIds = defineModel({ type: Array, default: () => [] });

const allSelected = computed(
  () =>
    props.items.length > 0 && selectedIds.value.length === props.items.length
);

const toggleAll = () => {
  selectedIds.value = allSelected.value ? [] : props.items.map(item => item.id);
};
</script>

<template>
  <div class="flex items-center gap-3">
    <label class="flex items-center gap-2 text-sm text-n-slate-12">
      <Checkbox :model-value="allSelected" @update:model-value="toggleAll" />
      {{ allSelected ? unselectAllLabel : selectAllLabel }}
    </label>
    <span v-if="selectedIds.length" class="text-sm text-n-slate-11">
      {{ selectedLabel }}
    </span>
    <Button
      v-if="selectedIds.length"
      :label="deleteLabel"
      color="ruby"
      variant="ghost"
      size="sm"
      icon="i-lucide-trash"
      @click="emit('bulkDelete')"
    />
  </div>
</template>
